<button-group>
    <div class="inline-flex rounded-md shadow-sm">
        <button type="button" class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10">Azioni</button>
        <div class="relative -ml-px block">
            <button type="button" onclick="{ toggleDropdown }" class="relative inline-flex items-center rounded-r-md bg-white px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10" id="option-menu-button" aria-expanded="true" aria-haspopup="true">
                <span class="sr-only">Open options</span>
                <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
            </button>
            <div if="{ state.isDropdownOpen }" class="absolute right-0 z-10 -mr-1 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="option-menu-button" tabindex="-1">
                <div class="py-1" role="none">
                    <!-- Active: "bg-gray-100 text-gray-900 outline-none", Not Active: "text-gray-700" -->
                    <a each="{ option in props.options }" class="block px-4 py-2 text-sm text-gray-700 text-left cursor-pointer" role="menuitem" tabindex="-1" onclick="{ () => handleOptionSelect(option) }">{ option.label }</a>
                </div>
            </div>
        </div>
    </div>
    
    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS, KEYS, CONFIG } from '/src/utils/constants'
        
        export default {
            onBeforeMount(props, state) {
                this.state = {
                    isDropdownOpen: false
                };
            },

            toggleDropdown() {
                this.update({ isDropdownOpen: !this.state.isDropdownOpen });
            },

            handleOptionSelect(option) {
                this.update({ isDropdownOpen: false }); // Chiudi il menu
                eventBus.trigger(EVENTS.UI.CLICK_BUTTON_GROUP, {
                    ckey: this.props.ckey,
                    action: option.action,
                    data: this.props.row,
                    params: option.params
                })
            }
        };
    </script>
</button-group>
